
export default {
  name: 'Typography',
  props: {
    strong: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md',
      validator: value =>
        Object.values({
          '4XL': '4xl',
          '3XL': '3xl',
          '2XL': '2xl',
          XL: 'xl',
          LG: 'lg',
          MD: 'md',
          SM: 'sm',
          XS: 'xs'
        }).includes(value)
    },
    tag: {
      type: String,
      default: 'p'
    },
    title: {
      type: String,
      default: undefined
    },
    href: {
      type: String,
      default: undefined
    },
    rel: {
      type: String,
      default: undefined
    },
    variant: {
      type: String,
      default: ''
    },
    html: {
      type: String,
      default: null
    }
  },
  computed: {
    styleClass() {
      const partialClass = {
        'text-strong': this.strong,
        'text-normal': !this.strong,
        'color-primary': this.variant === 'primary',
        'color-secondary': this.variant === 'secondary',
        'color-black-lighter': this.variant === 'black-lighter',
        'color-black-light': this.variant === 'black-light',
        'color-alert': this.variant === 'alert'
      }
      partialClass[`text-${this.size}`] = true
      return partialClass
    }
  }
}
